export const appRoutes = [
  { id: 1, name: "Home", path: "/home" },
  { id: 2, name: "About us", path: "/about-us" },
  { id: 3, name: "Join Us", path: "/join-us" },
  { id: 4, name: "Careers", path: "/careers" },
  { id: 5, name: "Contact", path: "/contact" },
];
